export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/deleteSchoolInfo',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allSchools'],
    })
